<template>
    <div :class="{ 'uk-form-icon': !!glyph , 'uk-height-1-1': !!height }" class="uk-width-1-1">
        <i
            v-if="!!glyph"
            :class="`uk-icon-${glyph}`"
        />
        <slot></slot>
    </div>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

export default {
    name: "InputGroup",
    mixins: [is_nibnut_component],
    props: {
        glyph: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: ""
        }
    }
}
</script>
